import type { ListTracesParams } from '@/api/langfuse.api'

export const TIME_RANGES = [
  { label: '过去 1 小时', hours: 1 },
  { label: '过去 6 小时', hours: 6 },
  { label: '过去 1 天', hours: 24 },
  { label: '过去 7 天', hours: 168 },
  { label: '过去 30 天', hours: 720 }
]

export const KEYWORD_TYPES = [
  { value: 'traceId', label: 'Trace ID', placeholder: '输入完整的 Trace ID' },
  { value: 'userName', label: '用户名', placeholder: '输入完整的用户名' }
] as const

export type TraceKeywordType = (typeof KEYWORD_TYPES)[number]['value']

export interface TraceSearch {
  /** 时间范围（小时），空表示全部 */
  hours: number | null
  /** 固定的起止时间，翻页时不变 */
  fromTimestamp?: string
  toTimestamp?: string
  keywordType: TraceKeywordType
  keyword: string
  /** 仅模板页使用：按实例过滤 */
  instanceId: string
}

export const EMPTY_TRACE_SEARCH: TraceSearch = {
  hours: null,
  keywordType: 'traceId',
  keyword: '',
  instanceId: ''
}

/** 设置时间范围并以当前时间固定起止时间。 */
export function withTimeRange(search: TraceSearch, hours: number | null): TraceSearch {
  if (hours === null) return { ...search, hours, fromTimestamp: undefined, toTimestamp: undefined }
  const now = Date.now()
  return {
    ...search,
    hours,
    fromTimestamp: new Date(now - hours * 3_600_000).toISOString(),
    toTimestamp: new Date(now).toISOString()
  }
}

export interface TraceInstanceOption {
  id: string
  name: string
}

/** 搜索条件转为 listTraces 参数 */
export function traceSearchParams(
  search: TraceSearch
): Pick<
  ListTracesParams,
  'fromTimestamp' | 'toTimestamp' | 'traceId' | 'userName'
> {
  const keyword = search.keyword.trim()
  return {
    fromTimestamp: search.fromTimestamp,
    toTimestamp: search.toTimestamp,
    traceId: search.keywordType === 'traceId' ? keyword : undefined,
    userName: search.keywordType === 'userName' ? keyword : undefined
  }
}
